export {precioUnitarioNeto} from './calculo-dte'

export const SIN_DATO = '--'

export const formatearDolaresOGuion = (valor: any): string => {
  const numero = typeof valor === 'number' ? valor : parseFloat(`${valor ?? ''}`.trim())
  if (!Number.isFinite(numero)) return SIN_DATO
  return numero.toLocaleString('es-SV', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'USD',
  })
}

export const formatearNum = (numero: any) => {
  if (numero !== 0 && !numero) return null
  return (
    numero.toLocaleString('es-SV', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      style: 'currency',
      currency: 'USD',
    }) ?? '--'
  )
}
